export default __webpack_public_path__ + "static/media/staking-card-1.470739c8.jpg";